import React from "react";
import BreadCrumb from "../componets/BreadCrumb";
import CopyWrite from "../componets/CopyWrite";
import { useParams } from "react-router-dom";
// Componetns
import Footer from "../componets/Footer";
import Header from "../componets/Header";
import Navbar from "../componets/Navbar";
import ShopSideBar from "../componets/shop/ShopSideBar";
import Products from "../componets/shop/Products";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import Profile from "../componets/Profile/Profile";
import RegisterForm from "../componets/Authentication/RegisterForm";
const src = "https://source.unsplash.com/random/200x200?sig=1";

const Profiles = () => {
  const params = useParams();
  // console.log("in shop", params.id);
  return (
    <div>
      {/* <Header /> */}
      <Navbar />

      {/* <!-- shop wrapper --> */}
      {/* <div className="container grid items-start gap-0 pt-4 pb-16 md:gap-6"> */}
        {/* <!-- breadcrumb --> */}
        {/* <!-- ./breadcrumb --> */}
      {/* </div> */}
      {/* <!-- ./Register --> */}
      <RegisterForm />
      {/* <!-- footer --> */}
      <Footer />
      {/* <!-- ./footer --> */}

      {/* <!-- copyright --> */}
      <CopyWrite />
      {/* <!-- ./copyright --> */}
    </div>
  );
};

export default Profiles;
